﻿(function ($) {
    $.fn.InitialiseSendToFriendForm = function (options) {
        var _divElement = this;

        // This is the easiest way to have default options
        var _settings = $.extend({
            errorClass: "invalid",
            validClass: "valid",
            onSubmitSuccess: undefined
        }, options);

        _divElement.find("form").validate({
            errorClass: _settings.errorClass,
            validClass: _settings.validClass,

            rules: {
                name: { required: true },
                friendEmail: { required: true, email: true }
            },
            onfocusout: function (element) {
                this.element(element);
            },
            onkeyup: function (element, event) {
                if (($(element).is("input:text") || $(element).attr('type').toLowerCase() == "email") && event.keyCode !== 9) {
                    this.element(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                $(element).parent().addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).parent('.' + errorClass).removeClass(errorClass);
            },
            success: function (element) { },
            errorPlacement: function (error, element) { },
            submitHandler: function (form) {

                var formData = $(form).serialize();
                var token = $('[name=__RequestVerificationToken]', '#AjaxAntiForgery').val();

                /* Code to disable Input fields and submit button */
                var submitButton = $(form).find("button[type='submit']");
                var submitButtonText = submitButton.text();
                submitButton.attr("disabled", true).text('Please Wait...');
                $(form).find("input:text, input[type=email]").attr("disabled", true);

                $.ajax({
                    url: '/service/' + $(form).attr('data-servercall'),
                    method: 'POST',
                    headers: { "x-csrf-token": token },
                    data: formData,
                    success: function (data) {
                        submitButton.text(submitButtonText);
                        _divElement.find('div.success').slideDown();
                    },
                    error: function (err, status, thrown) {
                        if ($(form).attr('data-error')) {
                            var ajaxError = 'Error: ' + $(form).attr('data-servercall') + ' - ' + (err.responseText || status || thrown || 'Unspecified error');
                            window[$(form).attr('data-error')](ajaxError, form);
                        }
                        alert("An error has occurred. Please try again.");
                        //Reload page after error to reset controls
                        location.reload();
                    }
                });
            }
        });
    };
}(jQuery));
